import React from 'react';
import { DatesSelectors } from '../aside-filters/dates/range-selection/DatesSelectors';
import { SearchFiltersDates } from './dates/SearchFiltersDates';
import { SearchFiltersCategory } from './categories/SearchFiltersCategory';
import { Connect, PropsFromRedux } from './SearchFiltersBarCommentaryContainer';
import {
  reportFilterToggle,
  filterActionTypes,
} from '../mobile-actions/filtersUtils';
import { SearchFiltersBarActions } from './SearchFiltersBarActions';
import { SearchCommentaryWatcher } from '../search-watcher/SearchCommentaryWatcher';
import { SearchFilterBarItem } from './SearchFilterBarItem';

type Props = PropsFromRedux;

const RawSearchFiltersBarCommentary: React.FunctionComponent<Props> = ({
  shouldDisplayPublisher,
  hasPublisherSelected,
  publisherCount,
  shouldDisplayCommentaryAccess,
  hasCommentaryAccessSelected,
  commentaryAccessCount,
  type,
  query,
  dateLabel,
  hasDateSelected,
}) => {
  function track(actionType: filterActionTypes, value: boolean) {
    reportFilterToggle(type, actionType, value);
  }
  return (
    <>
      <SearchFiltersDates
        label={dateLabel}
        isSelected={hasDateSelected}
        track={track}
      >
        <DatesSelectors type={type} />
      </SearchFiltersDates>
      {shouldDisplayPublisher && (
        <SearchFilterBarItem>
          <SearchFiltersCategory
            count={publisherCount}
            type="publisher"
            isSelected={hasPublisherSelected}
            track={track}
            searchType="commentary"
          />
        </SearchFilterBarItem>
      )}
      {shouldDisplayCommentaryAccess && (
        <SearchFilterBarItem>
          <SearchFiltersCategory
            count={commentaryAccessCount}
            type="commentaryAccess"
            isSelected={hasCommentaryAccessSelected}
            track={track}
            searchType="commentary"
          />
        </SearchFilterBarItem>
      )}

      <SearchFiltersBarActions>
        <SearchCommentaryWatcher query={query} />
      </SearchFiltersBarActions>
    </>
  );
};

export const SearchFiltersBarCommentary = Connect(
  RawSearchFiltersBarCommentary,
);
